<template>
<div class="dboard-card metric-card">
  <div class="row spacing align-items-center indent ">
    <div class="col-lg-5 border">
      <div class="dboard-card-title">
        Indented
      </div>
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="dboard-bar">
            <div class="v-bar-count">
              {{indentedCount}}
            </div>
            <div class="col-div">
            <div class="v-bar">
              <span class="v-bar-value" :style="{ height: indentPer + 'px' }">
              </span>
            </div>
          </div>

          <!-- <div class="col-div v-bar-content">
            <div class="v-bar-content-text">65% Within SLA (24H)</div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-7">
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="row">
            <div class="col bar-right-section-text">Accepted</div>
            <div class="col-3 count-style success-count">
              {{count.indent_accepted}}
            </div>
          </div>
           <div class="row">
            <div class="col bar-right-section-text">Rejected</div>
            <div class="col-3 count-style error-count">
              {{count.indent_rejected}}
            </div>
          </div>
           <div class="row">
            <div class="col bar-right-section-text">Pending</div>
            <div class="col-3 count-style warring-count">
              {{count.indented + count.indent_assign_due + count.indent_accept_due}}
            </div>
          </div>
            <div class="row">
            <div class="col bar-right-section-text">Change Truck</div>
            <div class="col-3 count-style error-count">
              {{count.truck_change_requested}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row spacing align-items-center assigned">
    <div class="col-lg-5 border">
      <div class="dboard-card-title">
        Assigned
      </div>
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="dboard-bar">
            <div class="v-bar-count">
              {{assignedCount}}
            </div>
            <div class="col-div">
            <div class="v-bar">
              <span class="v-bar-value" :style="{ height: assignedPer + 'px' }">
              </span>
            </div>
          </div>

          <!-- <div class="col-div v-bar-content">
            <div class="v-bar-content-text">74% Within SLA (24H)</div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-7">
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="row">
            <div class="col bar-right-section-text">Truck Rejected</div>
            <div class="col-3 bar-right-section-count">{{count.truck_rejected}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row spacing align-items-center assigned">
    <div class="col-lg-5 border">
      <div class="dboard-card-title">
        Arrived
      </div>
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="dboard-bar">
            <div class="v-bar-count">
              {{count.truck_arrived + count.loading_ended + count.loading_started}}
            </div>
            <div class="col-div">
            <div class="v-bar">
              <span class="v-bar-value" :style="{ height: arrivedPer + 'px' }">
              </span>
            </div>
          </div>

          <!-- // <div class="col-div v-bar-content">
          //   <div class="v-bar-content-text">65% Within SLA (24H)</div>
          // </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-7">
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <!-- <div class="row">
            <div class="col-div bar-right-section-text">SLA Breach</div>
            <div class="col-div bar-right-section-count">44</div>
          </div> -->
          <div class="row">
            <div class="col bar-right-section-text">Truck In</div>
            <div class="col-3 primary-count count-style">
              {{count.truck_arrived}}
            </div>
          </div>
          <div class="row">
            <div class="col bar-right-section-text">Inspected</div>
            <div class="col-3 primary-count count-style">
              {{count.truck_arrived}}
            </div>
          </div>
          <div class="row">
            <div class="col bar-right-section-text">Loading Start</div>
            <div class="col-3 primary-count count-style">
              {{count.loading_started}}
            </div>
          </div>
          <div class="row">
            <div class="col bar-right-section-text">Loading End</div>
            <div class="col-3 primary-count count-style">
              {{count.loading_ended}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row spacing align-items-center dispatched">
    <div class="col-lg-5 border">
      <div class="dboard-card-title">
        Dispatched
      </div>
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="dboard-bar">
            <div class="v-bar-count">
              {{count.dispatched}}
            </div>
            <div class="col-div">
            <div class="v-bar">
              <span class="v-bar-value" :style="{ height: dispatchedPer + 'px' }">
              </span>
            </div>
          </div>

          <!-- <div class="col-div v-bar-content">
            <div class="v-bar-content-text">74% Within SLA (24H)</div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
<!--     <div class="col-lg-7">
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="row">
            <div class="col bar-right-section-text">Transit Delay</div>
            <div class="col-3 count-style error-count">{{count.delayed}}</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  <div class="row spacing align-items-center delivered">
    <div class="col-lg-5 border">
      <div class="dboard-card-title">
        Delivered
      </div>
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="dboard-bar">
            <div class="v-bar-count">
              {{count.delivered + count.delivery_pending}}
            </div>
            <div class="col-div">
            <div class="v-bar">
              <span class="v-bar-value" :style="{ height: deliveredPer + 'px' }">
              </span>
            </div>
          </div>

          <!-- <div class="col-div v-bar-content">
            <div class="v-bar-content-text">65% Within SLA (24H)</div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-7">
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <!-- <div class="row">
            <div class="col bar-right-section-text">On Time In Full</div>
            <div class="col-4 count-style error-count">200</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
/* eslint-disable */
export default {
  props: {
    isLoading: {
      type: Boolean,
    },
    count: {
      type: Object,
    },
    sladata: {
      type: Object,
    },
    activeIntends: {
      type: Number,
    },
  },

  computed: {
    indentedCount() {
      return this.count.indented +
        this.count.indent_rejected +
        this.count.indent_assign_due +
        this.count.indent_accept_due +
        this.count.indent_accepted +
        this.count.truck_change_requested;
    },
    assignedCount() {
      return this.count.truck_assigned +
        this.count.truck_rejected +
        this.count.indent_arrived_due +
        this.count.reported;
    },
    indentPer() {
      return Math.ceil(( this.indent / (this.activeIntends + this.count.delivered)) * 100);
    },

    assignedPer() {
      return Math.ceil(((this.count.truck_assigned + this.count.truck_rejected) / (this.activeIntends + this.count.delivered)) * 100);
    },

    arrivedPer() {
      return Math.ceil(((this.count.truck_arrived + this.count.loading_started + this.count.loading_ended) / (this.activeIntends + this.count.delivered)) * 100);
    },

    dispatchedPer() {
      return Math.ceil(((this.count.dispatched) / (this.activeIntends + this.count.delivered)) * 100);
    },

    deliveredPer() {
      return Math.ceil(((this.count.delivered) / (this.activeIntends + this.count.delivered)) * 100);
    },

  }




}
</script>

<style lang="scss" scoped>
.metric-card .col-lg-7 {
  .dboard-card-panel-section {
    padding-top: 30px;
  }
}
</style>
